"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M0 1a1 1 0 011-1h18a1 1 0 011 1v3a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM0 8a1 1 0 011-1h18a1 1 0 011 1v4a1 1 0 01-1 1H1a1 1 0 01-1-1V8zM0 16a1 1 0 011-1h18a1 1 0 011 1v3a1 1 0 01-1 1H1a1 1 0 01-1-1v-3z"];
//# sourceMappingURL=layout-three-rows.js.map